<template>
	<div v-if="isModalReportOpen" class="modal">
		<button class="modal-backdrop" @click="$emit('close')"></button>
		<div class="pop-up black">
			<div class="top">
				<div class="modal-title">
					{{ $t("notification_component.modal_report.title") }}
				</div>
				<div class="modal-text">
					{{ $t("notification_component.modal_report.text") }}
				</div>
			</div>
			<select>
				<option selected>
					{{ $t("notification_component.modal_report.select") }}
				</option>
				<option>A</option>
				<option>B</option>
				<option>C</option>
			</select>
			<div class="texts">
				<div class="title-texts">
					{{ $t("notification_component.modal_report.title_text") }}
				</div>
				<div class="input-text">
					<textarea
						:placeholder="$t('notification_component.modal_report.textarea')"
						v-model="description"
						@input="updateRemainingCharacters"
						:maxlength="maxCharacters"
					></textarea>
					<small
						>{{ $t("notification_component.modal_report.caracteres") }}:
						{{ remainingCharacters }}</small
					>
				</div>
			</div>
			<div class="buttons">
				<div class="report-button" @click="$emit('close')">
					{{ $t("notification_component.modal_report.cancel") }}
				</div>
				<div class="confirm-button">
					{{ $t("notification_component.modal_report.confirm") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps({
	isModalReportOpen: Boolean,
});

const maxCharacters = 200;

const description = ref("");
const remainingCharacters = ref(maxCharacters);

const updateRemainingCharacters = () => {
	remainingCharacters.value = maxCharacters - description.value.length;
};
</script>

<style lang="scss" scoped>
.modal {
	width: 100vw;
	height: 100vh;
	z-index: 99999999999;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	.modal-backdrop {
		position: fixed;
		width: 100%;
		background-color: var(--modal-scrim);
		height: 100vh;
		border: none;
		outline: none;
		z-index: 1;
		left: 0;
		top: 0;
		display: block;
	}

	.pop-up {
		width: 100%;
		max-width: 400px;
		border: 1px solid var(--card-article-border);
		display: flex;
		flex-direction: column;
		gap: 12px;
		position: relative;
		z-index: 999;
		margin: 0 !important;
		padding: 32px;
		gap: 32px;
		flex: 1 0 0;
		.texts {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-self: stretch;
			.title-texts {
				font-size: 14px;
				font-weight: 400;
				line-height: 20px;
				color: var(--active);
			}
			.input-text {
				display: flex;
				flex-direction: column;
				gap: 4px;
				align-self: stretch;
				textarea {
					background-color: transparent;
					color: var(--secondary-info-fg);
					border: 1px solid var(--card-article-border);
					font-size: 14px;
					padding: 10px;
					font-weight: 400;
					height: 136px;
					line-height: 20px;
				}
				small {
					font-size: 12px;
					color: var(--secondary-info-fg);
					font-weight: 400;
					line-height: 16px;
				}
			}
		}
		select {
			background-color: transparent;
			color: var(--secondary-info-fg);
			border: 0;
			border-bottom: 1px solid var(--card-article-border);
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 24px;
			margin-top: 24px;
		}

		.top {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 8px;
			align-self: stretch;
			.modal-text {
				font-size: 12px;
				font-weight: 400;
				line-height: 16px;
				color: var(--secondary-info-fg);
			}
			.modal-title {
				font-size: 18px;
				font-weight: 600;
				line-height: 26px;
				color: var(--active);
			}
		}
		&.black {
			background: var(--sidebar-bg);
		}
		.buttons {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 8px;
			align-self: stretch;
			.confirm-button {
				background-color: var(--sidebar-menus-active-bg);
				text-align: center;
				font-size: 16px;
				color: var(--card-article-bg);
				font-weight: 400;
				line-height: 24px;
				height: 44px;
				padding: 0px 12px;
				align-content: center;
				cursor: pointer;
				width: 100%;
			}
			.report-button {
				color: var(--sidebar-menus-active-bg);
				background: var(--card-article-bg);
				text-align: center;
				font-size: 16px;
				font-weight: 400;
				line-height: 24px;
				align-content: center;
				height: 44px;
				padding: 0px 12px;
				cursor: pointer;
				width: 100%;
			}
		}
	}
}
</style>
